import React, { Component, Fragment } from 'react';
import { Amc } from '../models/singleFundPages';
import withAppLayout from '../components/appLayout';
import amcStyles from '../styles/amcs.scss';
import Header from '../components/nextHead';
import BreadCrumb from '../components/breadcrumb';
import AmcItem from '../components/amc/amcItem';

interface Props {
  amcs: Amc[];
}

class AmcList extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const { amcs } = this.props;
    const title =
      'Mutual Fund Schemes in India - List of All Fund Houses & Plans';
    const description =
      'ClearTax Invest offers different types of mutual fund investment schemes. Browse through all fund houses & their respective schemes in India and select the best plan suitable for you.';
    const breadCrumbItems = [
      {
        link: '/mutual-funds',
        text: 'Mutual funds',
      },
      {
        text: 'Fund Houses',
      },
    ];
    return (
      <Fragment>
        <div className="ml25">
          <BreadCrumb
            breadcrumbs={breadCrumbItems}
            linkStyles={amcStyles['breadcrumb-link']}
            className={amcStyles['breadcrumbs']}
          />
          <h4>Mutual Funds Companies Catalogue</h4>
        </div>
        <div className={amcStyles['amc-list']}>
          {amcs.map(amc => (
            <div key={`${amc.slug}${amc.amcName}`}>
              <AmcItem amc={amc} />
            </div>
          ))}
        </div>

        <Header
          title={title}
          description={description}
          canonicalUrl="https://cleartax.in/mutual-funds"
        />
      </Fragment>
    );
  }
}

export default withAppLayout({ hideDefaultCanonical: true }, AmcList);



// WEBPACK FOOTER //
// ./pages/amcs.tsx